









import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import analyze from "./admin/analyze.vue";
import { ResCode } from "@/api/baseDefine";
import { overviewRequest, OverviewReq } from "@/api/admin";
@Component({
  components: {
    analyze
  }
})
export default class Dashboard extends Vue {
  private currentRole: string = "analyze";
  private url =
    "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg";
  get name() {
    return UserModule.name;
  }

  get roles() {
    return [UserModule.roleName];
  }

  get logo() {
    return null;
  }
}
